import { render, staticRenderFns } from "./certiticateProHireXpList.vue?vue&type=template&id=38dedff4&scoped=true&"
import script from "./certiticateProHireXpList.vue?vue&type=script&lang=js&"
export * from "./certiticateProHireXpList.vue?vue&type=script&lang=js&"
import style0 from "./certiticateProHireXpList.vue?vue&type=style&index=0&id=38dedff4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dedff4",
  null
  
)

export default component.exports